import { DonationCategory } from "../Payment/constant";

export const recurrium = [
  "You can support the seva with a one-time donation for a month.",

  "Make a donation for a month and help continue the sacred service."
];

export const options = [
  {
    value: "option1",
    label: "Anna Daan",
    columns: ["Column 1", "Column 2", "Column 3"],
    data: ["Data 1", "Data 2", "Data 3"],
  },
  {
    value: "option2",
    label: "Gau Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option3",
    label: "Sadhu Bhojan",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option4",
    label: "Vidya Daan",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option5",
    label: "Youth Preaching Seva",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
  {
    value: "option6",
    label: "Temple Support",
    columns: ["Column A", "Column B", "Column C"],
    data: ["Data A", "Data B", "Data C"],
  },
];

export const option1: DonationCategory[] = [
  {
    title: "Anna Daan for this Month",
    donations: [
      { id: 1, title: "Donate Rs 500 for Anna Daan for this Month", amount: 500 },
      { id: 2, title: "Donate Rs 700 for Anna Daan for this Month", amount: 700 },
      { id: 3, title: "Donate Rs 1000 for Anna Daan for this Month", amount: 1000 },
      { id: 4, title: "Donate Rs 2000 for Anna Daan for this Month", amount: 2000 },
      { id: 5, title: "Donate Rs 3000 for Anna Daan for this Month", amount: 3000 },
      { id: 6, title: "Donate Rs 5000 for Anna Daan for this Month", amount: 5000 },
      { id: 7, title: "Donate Rs 10000 for Anna Daan for this Month", amount: 10000 },
    ],
  },
];

export const option2: DonationCategory[] = [
  {
    title: "Gau Seva for this Month",
    donations: [
      { id: 1, title: "Donate Rs 500 for Gau Seva for this Month", amount: 500 },
      { id: 2, title: "Donate Rs 700 for Gau Seva for this Month", amount: 700 },
      { id: 3, title: "Donate Rs 1000 for Gau Seva for this Month", amount: 1000 },
      { id: 4, title: "Donate Rs 2000 for Gau Seva for this Month", amount: 2000 },
      { id: 5, title: "Donate Rs 3000 for Gau Seva for this Month", amount: 3000 },
      { id: 6, title: "Donate Rs 5000 for Gau Seva for this Month", amount: 5000 },
    ],
  },
];

export const option3: DonationCategory[] = [
  {
    title: "Sadhu Bhojan for this Month",
    donations: [
      { id: 1, title: "Donate Rs 500 for Sadhu Bhojan for this Month", amount: 500 },
      { id: 2, title: "Donate Rs 700 for Sadhu Bhojan for this Month", amount: 700 },
      { id: 3, title: "Donate Rs 1000 for Sadhu Bhojan for this Month", amount: 1000 },
      { id: 4, title: "Donate Rs 2000 for Sadhu Bhojan for this Month", amount: 2000 },
      { id: 5, title: "Donate Rs 3000 for Sadhu Bhojan for this Month", amount: 3000 },
      { id: 6, title: "Donate Rs 5000 for Sadhu Bhojan for this Month", amount: 5000 },
    ],
  },
];

export const option4: DonationCategory[] = [
  {
    title: "Vidya Daan for this Month",
    donations: [
      { id: 1, title: "Donate Rs 500 for Vidya Daan for this Month", amount: 500 },
      { id: 2, title: "Donate Rs 700 for Vidya Daan for this Month", amount: 700 },
      { id: 3, title: "Donate Rs 1000 for Vidya Daan for this Month", amount: 1000 },
      { id: 4, title: "Donate Rs 2000 for Vidya Daan for this Month", amount: 2000 },
      { id: 5, title: "Donate Rs 3000 for Vidya Daan for this Month", amount: 3000 },
      { id: 6, title: "Donate Rs 5000 for Vidya Daan for this Month", amount: 5000 },
    ],
  },
];

export const option5: DonationCategory[] = [
  {
    title: "Youth Preaching Seva for this Month",
    donations: [
      {
        id: 1,
        title: "Donate Rs 500 for Youth Preaching Seva for this Month",
        amount: 500,
      },
      {
        id: 2,
        title: "Donate Rs 1000 for Youth Preaching Seva for this Month",
        amount: 1000,
      },
      {
        id: 3,
        title: "Donate Rs 2000 for Youth Preaching Seva for this Month",
        amount: 2000,
      },
      {
        id: 4,
        title: "Donate Rs 3000 for Youth Preaching Seva for this Month",
        amount: 3000,
      },
      {
        id: 5,
        title: "Donate Rs 4000 for Youth Preaching Seva for this Month",
        amount: 4000,
      },
      {
        id: 6,
        title: "Donate Rs 5000 for Youth Preaching Seva for this Month",
        amount: 5000,
      },
    ],
  },
];

export const option6: DonationCategory[] = [
  {
    title: "Temple Support for this Month",
    donations: [
      { id: 1, title: "Donate Rs 500 for Temple Support for this Month", amount: 500 },
      { id: 2, title: "Donate Rs 800 for Temple Suppor for this Montht", amount: 800 },
      {
        id: 3,
        title: "Donate Rs 1000 for Temple Support for this Month",
        amount: 1000,
      },
      {
        id: 4,
        title: "Donate Rs 2000 for Temple Support for this Month",
        amount: 2000,
      },
      {
        id: 5,
        title: "Donate Rs 3000 for Temple Support for this Month",
        amount: 3000,
      },
      {
        id: 6,
        title: "Donate Rs 5000 for Temple Support for this Month",
        amount: 5000,
      },
    ],
  },
];
